export default __webpack_public_path__ + "static/media/Trailer2.c36d5a10.jpg";